import request from '@/utils/request'

export function simulationStaticPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment',
    method: 'post',
    data
  })
}

export function simulationDynamicPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment/dynamic',
    method: 'post',
    data
  })
}

export function simulationCheckoutPayment(data) {
  return request({
    url: '/merchant-api/simulation/payment/checkout',
    method: 'post',
    data
  })
}

export function simulationDisbursement(data) {
  return request({
    url: '/merchant-api/simulation/payout',
    method: 'post',
    data
  })
}

export function simulationCollectionVerify(data) {
  return request({
    url: '/merchant-api/simulation/collection/verify',
    method: 'post',
    data
  })
}
